export const generateReferenceNumber = (invoiceNumber: string): string => {
  invoiceNumber = String(invoiceNumber).replace(/\D/g, '').padStart(3, 0)
  const weights = [7, 3, 1]
  const weightedSum = invoiceNumber.split('').reduceRight((acc, cv, ci, src) => {
    return acc + Number(cv) * weights[(src.length - 1 - ci) % 3]
  }, 0)
  return `${invoiceNumber}${Math.ceil(weightedSum / 10) * 10 - weightedSum}`
}

export const generateStructuredCommunication = () => {
  let base: string | number = Math.round(Date.now() / 2000)
  const modulo97 = base % 97
  base = base.toString().padStart(10, '0')
  return modulo97 === 0 ? `${base}${97}` : `${base}${modulo97.toString().padStart(2, '0')}`
}

export const getVisualStructuredCommunication = (sc: string) => {
  return `+++${sc.slice(0, 3)}/${sc.slice(3, 7)}/${sc.slice(7, 12)}+++`
}

// If the last digit is not a checksum, add checksum at the end. Else, leave as it is
export const correctReferenceNumber = (testRef: string): string => {
  if (!testRef) {
    return ''
  }
  const validRef = generateReferenceNumber(testRef.substring(0, testRef.length - 1))
  return validRef == testRef ? testRef : generateReferenceNumber(testRef)
}

export const correctStructuredCommunication = (testRef: string): string => {
  if (!testRef) {
    return ''
  }
  const num = testRef.replace(/\D/g, '')
  try {
    const modulo = Number(num.slice(0, 10)) / 97 || 97
    if (modulo !== Number(num.slice(10, 12))) {
      return generateStructuredCommunication()
    }
  } catch (e) {
    return generateStructuredCommunication()
  }
}
